import { DEFAULT_LANGUAGE } from 'unsubscribe-ui/utils/constants';
export const getPageLangLocale = (pathName = '') => {
  const routeSegments = pathName.split('/');
  // For confirmation route
  if (pathName.includes('/confirmation')) {
    return routeSegments.length >= 2 ? routeSegments[routeSegments.length - 3] : 'en';
  }
  // For contact route
  if (pathName.includes('/contact/')) {
    return routeSegments.length >= 2 ? routeSegments[routeSegments.indexOf('contact') - 1] : 'en';
  }
  if (routeSegments && routeSegments.length > 1) {
    const segmentsLength = routeSegments.length;
    const langLocale = routeSegments[segmentsLength - 2];
    return langLocale;
  }
  return DEFAULT_LANGUAGE;
};